import React from 'react';
import { Filter, TextInput, FilterProps } from 'react-admin';

const BackupFilter = (props: Omit<FilterProps, 'children'>) => (
    <Filter {...props}>
        <TextInput label='resources.admin/backups.fields.path' source="path" alwaysOn />
    </Filter>
);

export default BackupFilter;
